import { api } from "./configs/axiosConfigs"

export const driverAPI = {
    getDrivers: async (data?: any) => {
        const response = await api.get(
            '/driver',
            {
                params: {
                    ...data
                }
            }
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },
    create: async (data: any) => {
        const response = await api.post(
            '/driver/register', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },
    edit: async (id: number, data: any) => {
        const response = await api.patch(
        `/driver/${id}`,
        {
            ...data
        }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
    delete: async (id: number) => {
        const response = await api.delete(
        `/driver/${id}`
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    }
}